import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/nav/logo.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-59bdde78"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "header"
};
var _hoisted_2 = {
  "class": "content"
};
var _hoisted_3 = {
  "class": "item-left"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_5 = {
  "class": "item-right"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    "class": "icon-miniapp"
  }, null, -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    "class": "icon-custom"
  }, null, -1);
});
var _hoisted_8 = {
  "class": "scan"
};
var _hoisted_9 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createVNode(_component_router_link, {
    to: "/index"
  }, {
    "default": _withCtx(function () {
      return [_hoisted_4];
    }),
    _: 1
  }, 512), [[_vShow, $data.showLogo]])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    "class": "item",
    onMouseover: _cache[0] || (_cache[0] = function ($event) {
      return $options.showPopup(1);
    }),
    onMouseleave: _cache[1] || (_cache[1] = function ($event) {
      return $data.popupVisible = false;
    })
  }, [_hoisted_6, _createTextVNode("GLP-1助手 ")], 32), _createElementVNode("div", {
    "class": "item",
    onMouseover: _cache[2] || (_cache[2] = function ($event) {
      return $options.showPopup(2);
    }),
    onMouseleave: _cache[3] || (_cache[3] = function ($event) {
      return $data.popupVisible = false;
    })
  }, [_hoisted_7, _createTextVNode("在线咨询 ")], 32), $data.popupVisible ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    "class": "popup",
    style: _normalizeStyle({
      right: $data.right
    })
  }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $data.popupImg,
    alt: ""
  }, null, 8, _hoisted_9)]), _createElementVNode("h5", null, _toDisplayString($data.context), 1)], 4)) : _createCommentVNode("", true)])])]);
}